<div class="container h-full" id="activate-warranty">
  <div class="row h-full">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a href="javascript:void(0)" appBack fallbackUrl="/warranties" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'WARRANTIES.BTN_BACK_TO_WARRANTY' | translate }}</a>
      </div>
    </div>
    <hr role="presentation" class="w-full mb-4 mt-0 border-t">
    <div class="col-12 grow">
      <div class="view-content-wr h-full">
        <div class="row h-full">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <h3 class="pb-3">{{ 'WARRANTY_ACTIVATION.ACTIVATION_SETUP' | translate }}</h3>

            <p-stepper class="legacy-stepper" [value]="currentStepIndex + 1" [linear]="true">
              <p-step-list>
                @for (step of steps; track step; let stepIndex = $index) {
                  <p-step [value]="stepIndex + 1">
                    {{ step.label }}
                  </p-step>
                }
              </p-step-list>
            </p-stepper>

            <div class="flex flex-wrap justify-between mt-3 mb-5">
              <button data-testid="activate-warranty-previous-step" type="button" class="reset-btn border-none inline-flex items-center text-base link link-icon left-arrow-minimal" [ngClass]="{'hidden': currentStepIndex === 0 ||  currentStepIndex === 5}" (click)="onPreviousStep()">{{ 'WARRANTY_ACTIVATION.BTN_PREV_STEP' | translate }}</button>
              <span class="text-base">{{ 'WARRANTY_ACTIVATION.STEP_N_OF_N' | translate: { currentStep: currentStepIndex+1, totalSteps: getStepsCounter() } }}</span>
            </div>

            <div class="grow">
              @switch (steps[currentStepIndex]?.component) {
                @case ('select-retailer') {
                  <app-retailer-selection (stepSaved)="nextStep()"></app-retailer-selection>
                }
                @case ('activation-method') {
                  <app-activation-method (stepSaved)="nextStep()"></app-activation-method>
                }
                @case ('find-serialnumber') {
                  <app-serial-number-search (stepSaved)="nextStep()"></app-serial-number-search>
                }
                @case ('warranty-code') {
                  <app-warranty-code-validation (stepSaved)="nextStep()"></app-warranty-code-validation>
                }
                @case ('activation') {
                  <app-activate-warranty (stepSaved)="nextStep()"></app-activate-warranty>
                }
                @case ('summary') {
                  <app-activation-feedback (stepSaved)="nextStep()"></app-activation-feedback>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
